const TableauLogo = dynamic(() => import('@/components/Logos').then(it => it.TableauLogo));
const MetaLogo = dynamic(() => import('@/components/Logos').then(it => it.MetaLogo));
const DoorDashLogo = dynamic(() => import('@/components/Logos').then(it => it.DoorDashLogo));
const ElasticGoogleCloudLogo = dynamic(() => import('@/components/Logos').then(it => it.ElasticGoogleCloudLogo));
const PaxosLogo = dynamic(() => import('@/components/Logos').then(it => it.PaxosLogo));
const MicrosoftLogo = dynamic(() => import('@/components/Logos').then(it => it.MicrosoftLogo));
const AetnaLogo = dynamic(() => import('@/components/Logos').then(it => it.AetnaLogo));
const SpotifyLogo = dynamic(() => import('@/components/Logos').then(it => it.SpotifyLogo));
const SalesforceLogo = dynamic(() => import('@/components/Logos').then(it => it.SalesforceLogo));
const StashLogo = dynamic(() => import('@/components/Logos').then(it => it.StashLogo));
const TinderLogo = dynamic(() => import('@/components/Logos').then(it => it.TinderLogo));
const HingeLogo = dynamic(() => import('@/components/Logos').then(it => it.HingeLogo));
const RevolutLogo = dynamic(() => import('@/components/Logos').then(it => it.RevolutLogo));
const DeliveryHeroLogo = dynamic(() => import('@/components/Logos').then(it => it.DeliveryHeroLogo));
const SoundCloudLogo = dynamic(() => import('@/components/Logos').then(it => it.SoundCloudLogo));
const AppliedMaterialsLogo = dynamic(() => import('@/components/Logos').then(it => it.AppliedMaterialsLogo));
const PicPayLogo = dynamic(() => import('@/components/Logos').then(it => it.PicPayLogo));
const EarnInLogo = dynamic(() => import('@/components/Logos').then(it => it.EarnInLogo));
const NetflixLogo = dynamic(() => import('@/components/Logos').then(it => it.NetflixLogo));
const LinkedInLogo = dynamic(() => import('@/components/Logos').then(it => it.LinkedInLogo));
const ElasticLogo = dynamic(() => import('@/components/Logos').then(it => it.ElasticLogo));
const JamfLogo = dynamic(() => import('@/components/Logos').then(it => it.JamfLogo));
const ApolloLogo = dynamic(() => import('@/components/Logos').then(it => it.ApolloLogo));
const AndroidLogo = dynamic(() => import('@/components/Logos').then(it => it.AndroidLogo));
const PremiseLogo = dynamic(() => import('@/components/Logos').then(it => it.PremiseLogo));
const HiveMqLogo = dynamic(() => import('@/components/Logos').then(it => it.HiveMqLogo));
const AmazonRingLogo = dynamic(() => import('@/components/Logos').then(it => it.AmazonRingLogo));
const SpringBootLogo = dynamic(() => import('@/components/Logos').then(it => it.SpringBootLogo));
const CashAppLogo = dynamic(() => import('@/components/Logos').then(it => it.CashAppLogo));
const MicroMeterLogo = dynamic(() => import('@/components/Logos').then(it => it.MicroMeterLogo));
const CriteoLogo = dynamic(() => import('@/components/Logos').then(it => it.CriteoLogo));
const CollibraLogo = dynamic(() => import('@/components/Logos').then(it => it.CollibraLogo));
const ToastLogo = dynamic(() => import('@/components/Logos').then(it => it.ToastLogo));

import NetflixHero from './assets/netflix.jpg';
import TableauHero from './assets/tableau.jpg';
import EarnInHero from './assets/earn-in.jpg';
import PicPayHero from './assets/pic-pay.jpg';
import AppliedMaterialsHero from './assets/applied-materials.jpg';
import DeliveryHeroHero from './assets/delivery-hero.jpg';
import RevolutHero from './assets/revolut.jpg';
import HingeHero from './assets/hinge.jpg';
import PaxosHero from './assets/paxos.jpg';
import SpotifyHero from './assets/spotify.jpg';
import AetnaHero from './assets/aetna.jpg';
import dynamic from 'next/dynamic';
import { ComponentType } from 'react';
import { LogoPropsType } from '@/components/Logos/logoTypes';
import { StaticImageData } from 'next/image';

/*
  structure:
    name: name of company for searches or sorting
    icon: logo component
    heroImage: a 800x500 hero image for this company
    text: tagline text
    industry: industry company is in
    type: type of this entry
    target: link to entry
    targetText: text of link
    date: date of entry
    selector: identifier used to associate this entry with other data files and may appear in urls
*/
type SelectorType = string;

export interface CustomerDataType {
  name: string;
  icon: ComponentType<LogoPropsType>;
  heroImage?: StaticImageData;
  text: string;
  industry: string;
  type: 'Blog' | 'Customer story' | 'Video';
  targetText: string;
  target: string;
  date: number;
  selector: SelectorType;
}

export const customerData: ReadonlyArray<CustomerDataType> = [
  {
    name: 'Premise',
    icon: PremiseLogo,
    text: 'Premise Data experience with Gradle Build Cache node replication in Android',
    industry: 'Data & Analytics',
    type: 'Blog',
    targetText: 'Read Blog',
    selector: 'premise',
    date: 2021_03_04,
    target: 'https://dev.to/thedancercodes/gradle-build-cache-node-replication-in-android-14bc',
  },
  {
    name: 'LinkedIn (Faber)',
    icon: LinkedInLogo,
    text: 'Scaling Developer Productivity with Szcepan Faber of LinkedIn',
    industry: 'Social Media & Mobile',
    type: 'Blog',
    targetText: 'Read Blog',
    selector: 'linkedin_faber',
    target: '/blog/scaling-developer-productivity/',
    date: 2018_06_04,
  },
  {
    name: 'Netflix',
    icon: NetflixLogo,
    heroImage: NetflixHero,
    text: 'Develocity saves Netflix 280,000+ hours per year with faster builds and tests',
    industry: 'Entertainment & Media',
    type: 'Customer story',
    targetText: 'Read Case Study',
    selector: 'netflix',
    target: '/customers/story/netflix',
    date: 2023_11_01,
  },
  {
    name: 'Apollo Kotlin',
    icon: ApolloLogo,
    text: 'How Apollo Kotlin leverages Develocity to rev up build times',
    industry: 'Business Software',
    type: 'Blog',
    targetText: 'Read Blog',
    selector: 'apollo',
    target:
      'https://www.apollographql.com/blog/mobile/kotlin/how-apollo-kotlin-leverages-gradle-enterprise-to-rev-up-build-times/',
    date: 2023_07_17,
  },
  {
    name: 'Elastic',
    icon: ElasticLogo,
    text: 'Developer Productivity Engineering at Elastic: Avoiding the Cost of Inaction',
    industry: 'Business Software',
    type: 'Blog',
    targetText: 'Read Blog',
    selector: 'elastic',
    target: '/blog/developer-productivity-engineering-at-elastic/',
    date: 2020_03_20,
  },
  {
    name: 'Tableau',
    icon: TableauLogo,
    text: 'Improving the Developer Experience at Tabelau with Develocity',
    industry: 'Data & Analytics',
    type: 'Blog',
    targetText: 'Read Blog',
    selector: 'tableau_blog',
    target: '/blog/improve-developer-experience/',
    date: 2018_10_04,
  },
  {
    name: 'Tableau',
    icon: TableauLogo,
    heroImage: TableauHero,
    text: 'Tableau sees a 3-month payback in developer productivity with Develocity',
    industry: 'Data & Analytics',
    type: 'Customer story',
    targetText: 'Read Case Study',
    selector: 'tableau',
    target: '/customers/story/tableau',
    date: 2023_11_01,
  },
  {
    name: 'Jamf',
    icon: JamfLogo,
    text: 'Jamf Gets a Compelling ROI with Develocity Build & Test Performance Acceleration Technologies',
    industry: 'Business Software',
    type: 'Blog',
    targetText: 'Read Blog',
    selector: 'jamf',
    target: 'https://medium.com/jamf-engineering/build-and-test-acceleration-with-gradle-enterprise-37ac7a4599d9',
    date: 2023_04_01,
  },
  {
    name: 'EarnIn',
    icon: EarnInLogo,
    heroImage: EarnInHero,
    text: 'Develocity enables EarnIn to cut build and test feedback cycles by 75%',
    industry: 'Financial Services',
    type: 'Customer story',
    targetText: 'Read Case Study',
    selector: 'earnin',
    target: '/customers/story/earnin',
    date: 2023_07_01,
  },
  {
    name: 'PicPay',
    icon: PicPayLogo,
    heroImage: PicPayHero,
    text: 'PicPay sees payback within 3 months by developing Build Scan & Build Cache',
    industry: 'Financial Services',
    type: 'Customer story',
    targetText: 'Read Case Study',
    selector: 'picpay',
    target: '/customers/story/picpay',
    date: 2021_10_01,
  },
  {
    name: 'Applied Materials',
    icon: AppliedMaterialsLogo,
    heroImage: AppliedMaterialsHero,
    text: 'Develocity enables Applied Materials to reduce build time by 50% and recruit top talent by embracing DPE',
    industry: 'Manufacturing',
    type: 'Customer story',
    targetText: 'Read Case Study',
    selector: 'applied_materials',
    target: '/customers/story/applied_materials',
    date: 2023_08_01,
  },
  {
    name: 'Criteo',
    icon: CriteoLogo,
    text: 'Learn how Criteo used Develocity to reduce time-to-resolution for build failures from 30 minutes to 30 seconds',
    industry: 'Business Software',
    type: 'Blog',
    targetText: 'Read Blog',
    selector: 'criteo',
    target: '/blog/develocity-customer-story-criteo/',
    date: 2024_08_26,
  },
  {
    name: 'SoundCloud',
    icon: SoundCloudLogo,
    text: 'Leveraging remote Build Cache to solve cache misses and save developer time at SoundCloud',
    industry: 'Entertainment & Media',
    type: 'Blog',
    targetText: 'Read Blog',
    selector: 'soundcloud',
    target: 'https://developers.soundcloud.com/blog/gradle-remote-build-cache-misses',
    date: 2019_08_30,
  },
  {
    name: 'Delivery Hero',
    icon: DeliveryHeroLogo,
    heroImage: DeliveryHeroHero,
    text: 'Develocity helps Delivery Hero reduce build times by 50% and succeed with DevOps initiatives',
    industry: 'Retail/eCommerce',
    type: 'Customer story',
    targetText: 'Read Case Study',
    selector: 'delivery_hero',
    target: '/customers/story/delivery_hero',
    date: 2023_07_01,
  },
  {
    name: 'Revolut',
    icon: RevolutLogo,
    heroImage: RevolutHero,
    text: "Develocity cuts Revolut's build times by 75% for complex Android projects",
    industry: 'Financial Services',
    type: 'Customer story',
    targetText: 'Read Case Study',
    selector: 'revolut',
    target: '/customers/story/revolut',
    date: 2023_07_01,
  },
  {
    name: 'Hinge',
    icon: HingeLogo,
    heroImage: HingeHero,
    text: 'Develocity helps Hinge reduce build time by 50% and accelerate productivity initiatives',
    industry: 'Social Media & Mobile',
    type: 'Customer story',
    targetText: 'Read Case Study',
    selector: 'hinge',
    target: '/customers/story/hinge',
    date: 2023_08_01,
  },
  {
    name: 'Paxos',
    icon: PaxosLogo,
    heroImage: PaxosHero,
    text: 'Paxos views Develocity as mission-critical to their developer productivity strategy',
    industry: 'Financial Services',
    type: 'Customer story',
    targetText: 'Read Case Study',
    selector: 'paxos',
    target: '/customers/story/paxos',
    date: 2021_10_01,
  },
  {
    name: 'Tinder',
    icon: TinderLogo,
    text: 'Scaling Android builds in pandemic times at Tinder',
    industry: 'Social Media & Mobile',
    type: 'Video',
    targetText: 'Watch Webcast',
    selector: 'tinder',
    target: 'https://www.youtube.com/watch?v=WGCeHWEJQfw',
    date: 2021_03_22,
  },
  {
    name: 'Stash',
    icon: StashLogo,
    text: 'Stash experiences early benefits of Develocity solution for Developer Productivity Engineering',
    industry: 'Financial Services',
    type: 'Blog',
    targetText: 'Read Blog',
    selector: 'stash',
    target:
      '/blog/stash-experiences-early-benefits-of-gradle-enterprise-solution-for-developer-productivity-engineering/',
    date: 2020_07_20,
  },
  {
    name: 'Salesforce',
    icon: SalesforceLogo,
    text: 'Top Android Build Issues with Salesforce',
    industry: 'Business Software',
    type: 'Blog',
    targetText: 'Read Blog',
    selector: 'salesforce',
    target: '/blog/top-android-build-issues/',
    date: 2020_07_20,
  },
  {
    name: 'Spotify',
    icon: SpotifyLogo,
    heroImage: SpotifyHero,
    text: 'Spotify realizes build feedback cycle time improvements of up to 75%',
    industry: 'Entertainment & Media',
    type: 'Customer story',
    targetText: 'Read Case Study',
    selector: 'spotify',
    target: '/customers/story/spotify',
    date: 2020_07_20,
  },
  {
    name: 'Aetna',
    icon: AetnaLogo,
    heroImage: AetnaHero,
    text: "Develocity exceeds Aetna's expectations for scalability, service and support",
    industry: 'Healthcare & Pharma',
    type: 'Customer story',
    targetText: 'Read Case Study',
    selector: 'aetna',
    target: '/customers/story/aetna',
    date: 2021_09_01,
  },
  {
    name: 'Elastic & Google Clouod Platform',
    icon: ElasticGoogleCloudLogo,
    text: 'Dev cloud acceleration with Elastic and Google Cloud Plattform',
    industry: 'Business Software',
    type: 'Video',
    targetText: 'Watch Webcast',
    selector: 'elastic_google',
    target: 'https://www.youtube.com/watch?v=ltVD87kVpEM',
    date: 2021_03_23,
  },
  {
    name: 'Microsoft',
    icon: MicrosoftLogo,
    text: 'How Microsoft does Developer Productivity Engineering with Brian Houck',
    industry: 'Consumer Technology',
    type: 'Video',
    targetText: 'Watch Webcast',
    selector: 'microsoft',
    target: 'https://www.youtube.com/watch?v=1xP72VhpT1U',
    date: 2021_11_16,
  },
  {
    name: 'AndroidX',
    icon: AndroidLogo,
    text: 'How AndroidX does Developer Productivity Engineering with Aurimas Liutikas',
    industry: 'Business Software',
    type: 'Video',
    targetText: 'Watch Webcast',
    selector: 'andoidx',
    target: 'https://www.youtube.com/watch?v=Gr96IxKwPeE',
    date: 2022_04_04,
  },
  {
    name: 'DoorDash',
    icon: DoorDashLogo,
    text: 'How DoorDash does Developer Productivity Engineering with Adam Rogal',
    industry: 'Retail/eCommerce',
    type: 'Video',
    targetText: 'Watch Webcast',
    selector: 'doordash',
    target: 'https://www.youtube.com/watch?v=MN9U-JmRFJA',
    date: 2022_01_28,
  },
  {
    name: 'Netflix',
    icon: NetflixLogo,
    text: 'How Netflix does Developer Productivity Engineering with Danny Thomas',
    industry: 'Entertainment & Media',
    type: 'Video',
    targetText: 'Watch Webcast',
    selector: 'netflix_webcast',
    target: 'https://gradleinc.wistia.com/medias/4ai1bda223',
    date: 2022_08_03,
  },
  {
    name: 'LinkedIn',
    icon: LinkedInLogo,
    text: 'How LinkedIn does Developer Productivity Engineering with Grant Jenks',
    industry: 'Social Media & Mobile',
    type: 'Video',
    targetText: 'Watch Webcast',
    selector: 'linkedin_webcast',
    target: 'https://www.youtube.com/watch?v=pjNMPmdcLh4',
    date: 2021_12_13,
  },
  {
    name: 'Meta',
    icon: MetaLogo,
    text: 'How Meta does Developer Productivity Engineering with Adam McCormick',
    industry: 'Social Media & Mobile',
    type: 'Video',
    targetText: 'Watch Webcast',
    selector: 'meta',
    target: 'https://www.youtube.com/watch?v=fm2e3w0u5SQ',
    date: 2022_03_18,
  },
  {
    name: 'Micrometer',
    icon: MicroMeterLogo,
    text: 'Improving Micrometer’s build with Develocity',
    industry: 'Business Software',
    type: 'Blog',
    targetText: 'Read Blog',
    selector: 'micrometer_blog',
    target: 'https://gradle.com/blog/improving-micrometers-build-with-gradle-enterprise/ ',
    date: 2022_04_01,
  },
  {
    name: 'Cash App',
    icon: CashAppLogo,
    text: 'Managing a remote Build Cache at scale with local build observability at Cash App',
    industry: 'Financial Services',
    type: 'Blog',
    targetText: 'Read Blog',
    selector: 'cash_app_blog',
    target: 'https://gradle.com/blog/managing-a-remote-build-cache-at-scale-with-local-build-observability-at-cash-app',
    date: 2023_01_31,
  },
  {
    name: 'Spring Boot',
    icon: SpringBootLogo,
    text: 'From hour-long builds to streamlined productivity: The Spring Boot Journey',
    industry: 'Business Software',
    type: 'Blog',
    targetText: 'Read Blog',
    selector: 'spring_boot_blog',
    target: 'https://gradle.com/blog/from-hour-long-builds-to-streamlined-productivity-the-spring-boot-journey/',
    date: 2023_06_02,
  },
  {
    name: 'Hive MQ',
    icon: HiveMqLogo,
    text: 'HiveMQ’s mission-critical software testing process relies on Develocity to minimize feedback cycles without compromising quality',
    industry: 'Data & Analytics',
    type: 'Blog',
    targetText: 'Read Blog',
    selector: 'hivemq_blog',
    target:
      'https://gradle.com/blog/hivemq-mission-critical-software-testing-process-relies-on-develocity-to-minimize-feedback-cycles-without-compromising-quality/',
    date: 2023_12_19,
  },
  {
    name: 'Netflix',
    icon: NetflixLogo,
    text: 'Netflix pursues soft DevEx Goals with hard DevProd metrics using Test Distribution',
    industry: 'Entertainment & Media',
    type: 'Blog',
    targetText: 'Read Blog',
    selector: 'netflix_blog_devex',
    target:
      'https://gradle.com/blog/netflix-pursues-soft-devex-goals-with-hard-devprod-metrics-using-test-distribution/',
    date: 2022_01_19,
  },
  {
    name: 'Netflix',
    icon: NetflixLogo,
    text: 'Seven ways Netflix uses Develocity to manage Gradle plugins',
    industry: 'Entertainment & Media',
    type: 'Blog',
    targetText: 'Read Blog',
    selector: 'netflix_blog_plugins',
    target: 'https://gradle.com/blog/seven-ways-netflix-uses-gradle-enterprise-to-manage-gradle-plugins/',
    date: 2022_03_10,
  },
  {
    name: 'Amazon Ring',
    icon: AmazonRingLogo,
    text: 'How Amazon | Ring leverages Develocity to drive their DPE Initiative',
    industry: 'Consumer Technology',
    type: 'Video',
    targetText: 'Watch Video',
    selector: 'amazon_ring_video',
    target: 'https://gradleinc.wistia.com/medias/y5vmeti7vk',
    date: 2023_07_20,
  },
  {
    name: 'Collibra',
    icon: CollibraLogo,
    text: 'Collibra uses Develocity to cut CI build times by 60% and fast-track flaky test detection and resolution',
    industry: 'Data & Analytics',
    type: 'Blog',
    targetText: 'Read Blog',
    selector: 'collibra_blog',
    target: 'https://gradle.com/blog/develocity-customer-story-collibra/',
    date: 2025_02_06,
  },
  {
    name: 'Toast',
    icon: ToastLogo,
    text: 'Toast turns up the heat on slow builds with Gradle and DPE',
    industry: 'Data & Analytics',
    type: 'Blog',
    targetText: 'Read Blog',
    selector: 'toast_blog',
    target: 'https://thenewstack.io/toast-turns-up-the-heat-on-slow-builds-with-gradle-dpe/',
    date: 2025_04_03,
  },
];

export default customerData;

export function getDataBySelector(selector: SelectorType) {
  return customerData.find(customer => customer.selector === selector)!;
}
